import React, { ReactNode } from 'react';

import { Tooltip } from '../atoms/tooltip';

interface Props {
  tooltip?: string;
  disabled?: boolean;
  children: ReactNode;
}

export const DisabledWithTooltip = ({ disabled, tooltip = 'Event has been already sent to processor', children }: Props) => {
  if (disabled) {
    return <Tooltip tooltip={tooltip}>{children}</Tooltip>;
  }
  return children;
};
